/** 访问域名 */
const BETA_DOMAIN = "betaspps.bosiny.com.cn"; // 测试
const OFFCIAL_DOMAIN = "spps.bosiny.com.cn"; //正式
const NANCHONG_DOMAIN = "spps.ncgzzh.com"; //南充

/** 请求域名 */
const REQ_URL_LIST = {
    'LOCAL': 'http://192.168.0.207:8081', // 测试ip
    'BETA': "http://beta.bosiny.com.cn",//测试域名
    'OFFCIAL': "https://mch.bosiny.com.cn",//正式服务器
    'NANCHONG': "https://spps.ncgzzh.com/mch",//南充
}
/** 广告域名 */
const AD_URL_LIST = {
    // 'BETA': 'http://1982m2896v.51mypc.cn:19216/ad',
    'BETA': 'http://smartzoon.source.bosiny.com.cn:10075/ad/spps',
    'OFFCIAL': 'http://smartzoon.source.bosiny.com.cn:10075/ad/spps',
}

const handleUrl = (urlList,isCommon)=>{
    const _host = window.location.hostname;
    if(_host == OFFCIAL_DOMAIN){
        return urlList.OFFCIAL
    }else if(_host == BETA_DOMAIN){
        return urlList.BETA
    }else if(_host == NANCHONG_DOMAIN&&isCommon){
        return urlList.NANCHONG
    }else{
        return urlList.BETA
    }
}
/** 根据访问域名自动切换接口请求域名 */
const REQUEST_URL = handleUrl(REQ_URL_LIST,true)

/** 根据访问域名自动切换广告请求域名 */
const AD_URL = handleUrl(AD_URL_LIST,false)


//获取统计数据接口
const DETAIL = {
    CAR_DETAIL:  REQUEST_URL +"/api/js/berth",//获取寻车信息
    QRCODE_URL:  REQUEST_URL +"/sem/qrcode/follow/",//二维码地址
    SEARCH_CARNUM_HISTORY:  REQUEST_URL +"/api/js/history_vehicleno_list",//查询历史车牌记录
    NO_BODY_DUTY_SAN:  REQUEST_URL +"/api/js/scan_to_open",//无人值守扫码
    GET_DISCOUNT_COUPON:  REQUEST_URL +"/api/js/take_coupon",//扫码领取优惠券
    QUERY_SETMEAL_BY_VEHICLE:  REQUEST_URL +"/api/js/query_setmeal_by_vehicle",//根据车牌号查询停车场和车位
    COMMIT_SETMEAL_RENEW:  REQUEST_URL +"/api/js/commit_setmeal_renew",//获取费用接口（套餐充值）
    NO_SINGLE_PARKING_PAY:  REQUEST_URL +"/api/js/recharge_pay",//套餐充值支付
    // GET_LOCK_STATUS: REQUEST_URL +"/api/js/feemount",//获取车辆锁定状态（就是费用查询接口）
    LOCK_CAR: REQUEST_URL +"/api/js/lock_vehicle",//锁车/解锁
    GET_AUTH_CODE: REQUEST_URL +"/api/js/lock_verify_code",//获取验证码（锁车）
    REGISTER: REQUEST_URL +"/api/js/spps/regist",//注册
    LOGIN: REQUEST_URL +"/api/js/spps/login",//登录
    RESET_PASSWORD: REQUEST_URL +"/api/js/spps/reset",// 重置密码
    UPDATE_INFO: REQUEST_URL +"/api/js/spps/info",// 信息变更
    BIND_CAR: REQUEST_URL +"/api/js/spps/addcar",// 绑定车辆
    UNBIND_CAR: REQUEST_URL +"/api/js/spps/removecar",// 解绑车辆
    GET_LOCK_STATUS: REQUEST_URL +"/api/js/query_vehicle_status",// 获取车辆锁定状态
    GET_OPENINVOICE_STATUS: REQUEST_URL +"/api/js/nuonuo/haveOpenInvoice",// 检查是否已经开具发票
    OPEN_INVOICE: REQUEST_URL +"/api/js/nuonuo/openInvoice",// 开具发票
    // GET_EK_OPEN_STATUS: REQUEST_URL +"/api/js/invoice/openStatus",// 萌度供应商开票回调接口查询是否已经开具发票
    GET_ORDER: REQUEST_URL +"/api/js/queryPersonalPayRecord",// 查订单
    GET_INVOICE_TYPE: REQUEST_URL +"/api/js/invoice/type",// 电子发票使用平台
    GET_PARKS: REQUEST_URL +"/api/js/car/parks",// 根据车牌获取可开票的停车场
    GET_PARK_PAYRECORD: REQUEST_URL +"/api/js/park/payRecord",// 根据车牌在这个停车场下的缴费记录
    OPEN_INVOICEv2: REQUEST_URL +"/api/js/nuonuo/openInvoice/v2",// 开具发票2
    GET_CARLIST: REQUEST_URL +"/api/js/park/carList",// 获取用户车辆列表
    GET_CITY_BY_LBS: REQUEST_URL +"/api/map/reverse_geocoding",// 根据经纬度获取省市区
    GET_CITY_BY_IP: REQUEST_URL +"/api/map/location/ip",// 根据ip获取省市区
    GET_TRANSFER: REQUEST_URL +"/api/js/transfer/do",//领取零钱
    GET_CARNUM_HISTORY:  REQUEST_URL +"/api/js/history_vehicleno_list/coupon",//查询优惠券历史车牌记录
    GET_COMM_LIST:  REQUEST_URL +"/api/js/park/smartRoute/200194",//查询社区
    GET_PARKING_LIST:  REQUEST_URL +"/api/js/park/smartRoute/100208",//查询停车场
    GET_CAR_LIST:  REQUEST_URL +"/api/js/park/smartRoute/100210",//查询月卡车
    SET_CAR:  REQUEST_URL +"/api/js/park/smartRoute/100209",//注册月卡车
}
//百度地图pai
const BD_API = {
    BD_AK : "MZxdUgouVKXjGfDSlByLdKTQ1GNkUoDm",//百度地图ak秘钥
    GET_SOSITION:"/geocoder/v2/",//获取经纬度、省市区
}
const GD_API = {
    GD_KEY:"2425e5083e86c2d5de0ad4ec5d03451c"
}
export{
    REQUEST_URL,
    DETAIL,
    BD_API,
    AD_URL
}


// WEBPACK FOOTER //
// ./src/assets/api.js